import LocalSession from "./local_session"

class SessionManager {
  constructor({ envatoSso, clientSlug, ui }) {
    this.clientSlug = clientSlug
    this.envatoSso = envatoSso
    this.ui = ui

    this.state = SessionManager.PASSWORD_STATE
  }

  autoSignIn() {
    this.envatoSso.autoSignIn({
      onSuccess: (token) => this._autoSignInOnSuccess(token),
      onFailure: (m) => this._autoSignInOnFailure(m),
      onError: (m, e) => this._autoSignInOnError(m, e),
    })
  }

  signOut() {
    this.envatoSso.signOut({
      data: { to: this.clientSlug },
      onSuccess: () => this._signOutOnSuccess(),
      onFailure: () => this._signOutOnFailure(),
      onError: () => this._signOutOnError(),
    })
  }

  signIn() {
    this.ui.clearError()
    let data = this.ui.getSignInData()
    data = { ...data, to: this.clientSlug }
    switch (this.state) {
      case SessionManager.TWO_FACTOR_STATE:
        data = { ...data, ...this.ui.getTwoFactorData() }
        break
      case SessionManager.CAPTCHA_STATE:
        data = { ...data, ...this.ui.getRecaptchaData() }
        break
    }

    this.envatoSso.signIn({
      data: data,
      onSuccess: (token) => this._signInOnSuccess(token),
      onFailure: (message) => this._signInOnFailure(message),
      onError: (message, error) => this._signInOnError(message, error),
      onCaptchaRequired: () => this._signInOnCaptchaRequired(),
      onCaptchaInvalid: (message) => this._signInOnCaptchaInvalid(message),
      onTwoFactorRequired: () => this._signInOnTwoFactorRequired(),
      onTwoFactorInvalid: (message) => this._signInOnTwoFactorInvalid(message),
      onSignInVerification: (token) => this._signInOnSignInVerification(token),
      onForcedPasswordReset: () => this._signInOnForcedPasswordReset(),
      onEmailConfirmationRequired: () => this._signInOnEmailConfirmationRequired(),
    })
  }

  // private methods
  _autoSignInOnSuccess(token) {
    this._signInLocalSession(token)
  }

  _autoSignInOnFailure(message) {
    this.ui.showLoginForm()
  }

  _autoSignInOnError(message, e) {
    this.ui.displayError(message, e)
  }

  _signOutOnSuccess() {
    LocalSession.signOut()
  }

  _signOutOnFailure(message) {}

  _signOutOnError(message) {}

  _signInOnFailure(message) {
    this.ui.displayError(message)
  }

  _signInOnSuccess(token) {
    this._signInLocalSession(token)
  }

  _signInOnError(message) {
    this.ui.displayError(message)
  }

  _signInOnTwoFactorRequired() {
    this._transition(SessionManager.TWO_FACTOR_STATE)
  }

  _signInOnTwoFactorInvalid(message) {
    this.ui.displayError(message)
    this.ui.clearTwoFactor()
  }

  _signInOnCaptchaRequired() {
    this._transition(SessionManager.CAPTCHA_STATE)
  }

  _signInOnCaptchaInvalid(message) {
    this.ui.displayError(message)
    this.ui.resetRecaptcha()
  }

  _signInOnSignInVerification(token) {
    this._transition(SessionManager.SIGNIN_VERIFICATION_STATE, token)
  }

  _signInOnForcedPasswordReset() {
    this.ui.hideLoginForm()
    this.ui.showForcedPasswordReset()
  }

  _signInOnEmailConfirmationRequired() {
    this.ui.hideLoginForm()
    this.ui.showEmailConfirmation()
  }

  _signInLocalSession(token) {
    LocalSession.signIn(token, (message) => this.ui.displayError(message))
  }

  _transition(newState, data) {
    if (this.state === newState) {
      return
    }
    this._exiting(this.state)
    this._entering(newState, data)
  }

  _exiting(state) {
    this.state = state
    switch (state) {
      case SessionManager.TWO_FACTOR_STATE:
        this.ui.hideTwoFactor()
        break
      case SessionManager.CAPTCHA_STATE:
        this.ui.hideRecaptcha()
        break
      case SessionManager.PASSWORD_STATE:
        break
      default:
        break
    }
  }

  _entering(state, data) {
    this.state = state
    switch (state) {
      case SessionManager.TWO_FACTOR_STATE:
        this.ui.showTwoFactor()
        break
      case SessionManager.CAPTCHA_STATE:
        this.ui.showRecaptcha()
        break
      case SessionManager.SIGNIN_VERIFICATION_STATE:
        this.ui.showVerificationForm(data)
        break
      default:
        break
    }
  }
}

SessionManager.PASSWORD_STATE = "password"
SessionManager.TWO_FACTOR_STATE = "2FA"
SessionManager.CAPTCHA_STATE = "captcha"
SessionManager.SIGNIN_VERIFICATION_STATE = "SignInVerification"
SessionManager.FORCED_RESET_STATE = "ForcedPasswordReset"
SessionManager.EMAIL_CONFIRMATION_STATE = "EmailConfirmation"

export default SessionManager
